import { Theme, ThemeDefinition } from '@omegagrid/core';

export const tmReportingLight: Theme = {
	name: 'rp-light',
	type: 'light',
	accentColor: '#2a9ba5',
	definition: {
		'base-shadow': '0 4px 10px rgba(0,0,0,0.08)',
		'button-color': 'var(--og-accent-color)',
		'button-background-color': '#ffffff',
		'button-background-color-highlight': '#dce6f0',
		'background-color': '#eaf0f6',
		'background-color-2': '#f5f8fc',
		'background-color-3': '#dce6f0',
		'text-highlight-color': '#2a9ba5',
		'text-color': '#1c4072',
		'text-color-2': '#152035',
		'text-color-3': '#152035',
		'text-color-reversed': '#ffffff',
		'border': '#bfcbda',
		'border-color': '#bfcbda',
		'border-color-2': '#d2dce8',
		'border-color-3': '#90a0b4',
		'cell-background': '#f5f8fc',
		'cell-border': '1px solid #bfcbda',
		'hcell-background': '#dce6f0',
		'slider-background-color': '#e0e8f0',
		'slider-background-active': '#d0dae8',
		'slider-bar-color': '#b0bccb',
		'slider-bar-active': '#b0bccb',
		'expander-color': '#7888a0',
		'expander-hover': '#2a9ba5',
		'expander-background-color': '#bfcbda',
		'sizer-background': '#2a9ba5',
		'frozen-border': '#b0bccb',
		'inset-shadow-color': '#bfcbda',

		'commands-color': '#152035',
		'commands-background': '#eaf0f6',
		'commands-header-background': '#dce6f0',
		'commands-input-background': '#f5f8fc',
		'commands-shadow': '#b0bccb',

		'dialog-color': '#152035',
		'dialog-background': '#eaf0f6',
		'dialog-header-background': '#dce6f0',
		'dialog-shadow': '#b0bccb',

		'tab-border-color': '#bfcbda',
		'tab-background-color': '#eaf0f6',
		'tab-panel-background-color': '#eaf0f6',
		'tab-background-color-active': '#f5f8fc',

		'bucket-tab-background-color': '#dce6f0',
		'bucket-tab-panel-background-color': '#f5f8fc',
		'bucket-tab-background-color-active': '#f5f8fc',
		'bucket-right-background-color': '#f5f8fc',
		'bucket-border-color': '#bfcbda',
		'bucket-center-background-color': '#eaf0f6',
		'bucket-left-background-color': '#eaf0f6',
		'bucket-top-background-color': '#eaf0f6',
		'bucket-sidebar-background-color': '#e0e8f0',

		'form-background-color': '#dce6f0',

		'colortype-yellow-background-color': '#b8975a',
		'colortype-yellow-border-color': '#9a7e48',
		'colortype-yellow-text-color': '#ffffff',

		'colortype-green-background-color': '#4a9a80',
		'colortype-green-border-color': '#3a8068',
		'colortype-green-text-color': '#ffffff',

		'colortype-red-background-color': '#a8606a',
		'colortype-red-border-color': '#8e4e58',
		'colortype-red-text-color': '#ffffff',

		'colortype-blue-background-color': '#5a88b0',
		'colortype-blue-border-color': '#4a7298',
		'colortype-blue-text-color': '#ffffff',

		'colortype-gray-background-color': '#bfcbda',
		'colortype-gray-border-color': '#a8b6c8',
		'colortype-gray-text-color': '#152035',

		'colortype-accent-text-color': '#ffffff',

		'switch-background-color': '#b0bccb',
		'switch-slider-color': '#ffffff',

		'code-background-color': '#f5f8fc',

		'highcharts-title-font-size': '16px',
		'highcharts-subtitle-font-size': '14px',

		/* Colors for data series and points */
		'highcharts-color-0': '#2a9ba5',
		'highcharts-color-1': '#5a7ebc',
		'highcharts-color-2': '#3a9e72',
		'highcharts-color-3': '#c47a48',
		'highcharts-color-4': '#7b6eb0',
		'highcharts-color-5': '#d06a78',
		'highcharts-color-6': '#3ab0a0',
		'highcharts-color-7': '#8a8e40',
		'highcharts-color-8': '#b08a5a',
		'highcharts-color-9': '#5a8ab0',

		'highcharts-background-color': '#f5f8fc',

		/*
			Neutral color variations — blue-tinted grays (dark to light)
			https://www.highcharts.com/samples/highcharts/css/palette-helper
		*/
		'highcharts-neutral-color-100': '#152035',
		'highcharts-neutral-color-80': '#3a4a65',
		'highcharts-neutral-color-60': '#6a7a92',
		'highcharts-neutral-color-40': '#8b9ab0',
		'highcharts-neutral-color-20': '#bfcbda',
		'highcharts-neutral-color-10': '#dce6f0',
		'highcharts-neutral-color-5': '#eaf0f6',
		'highcharts-neutral-color-3': '#f5f8fc',

		/* Highlight color variations — teal-tinted (dark to light) */
		'highcharts-highlight-color-100': '#2a9ba5',
		'highcharts-highlight-color-80': '#48b0b8',
		'highcharts-highlight-color-60': '#6ec5cc',
		'highcharts-highlight-color-20': '#c4e6ea',
		'highcharts-highlight-color-10': '#e0f2f4',
	},
};
